<template>
  <div class="table-container pull-auto">
    <div class="avue-crud">
      <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow" @search-change="searchChange">
            <template slot="search">
                <el-form-item label="关键字">
                    <el-input placeholder="请输入关键字" v-model="form.condition" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.state" placeholder="请选择" clearable>
                        <el-option  v-for="item in workerState" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template slot-scope="scope" slot="menuLeft">
              <el-button class="filter-item" size="mini" @click="examine" type="primary" icon="el-icon-view"  :disabled = "derail">查看
            </el-button>
            <el-button class="filter-item" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline"  :disabled = "coldderail">冻结
            </el-button>
            <el-button class="filter-item" size="mini" @click="handleStart" type="primary" icon="el-icon-circle-check-outline"  :disabled = "nocoldderail">解冻
            </el-button>
            <el-button class="filter-item" size="mini" @click="deletestate" type="primary" icon="el-icon-circle-check-outline"  :disabled = "derail">删除
            </el-button>
            </template>
            <template slot-scope="scope" slot="userId">
                <el-radio class="radio" v-model="radio"  :label="scope.row.userId"></el-radio>
            </template>
             <template slot-scope="scope" slot="workTypeIds">
                {{scope.row.workTypeIds?setWorktype(scope.row.workTypeIds):''}}
            </template>
        </avue-crud>
      </div>
       <workerinfo ref="childworker" @refresh="refresh"></workerinfo>
       <workercald ref="childcald" @refresh="refresh"></workercald>
    </div>
  </div>
</template>

<script>
  import {fetchList,stop,getObj,dictionary,deleteWorker} from '@/api/admin/workerUser'
  import { objKeySort } from '@/util/ajaxsign'
  import {workerstable} from '@/const/asset/user'
  import workerinfo from './workinfo.vue'
  import workercald from './workercald.vue'
  export default {
    name: 'table_user',
    components: {workerinfo,workercald},
    data() {
      return {
        permissions : [],
        // 搜索
        form: {
            condition: '',
            state:''
        },
        radio:'',
        list: [],
        derail : true,
        coldderail : true,
        nocoldderail : true,
        listLoading: true,
        dictionarylist : {},
        workerState : [{value:1,label:"待审核"},{value:0,label:"未实名"},{value:2,label:"已实名"},{value:3,label:"已拒绝"},{value:4,label:"已冻结"}],
        totalStatus : true,
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableOption : workerstable,
      }
    },
    computed: {},
    created() {
      this.getList()
      this.dictionarydata()
      this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
      for(var i=0;i<this.permissions.length;i++){
          if(this.permissions[i] == 'sys_user_add'){
            this.sys_user_add = this.permissions[i]
          }
          if(this.permissions[i] == 'sys_user_edit'){
            this.sys_user_edit = this.permissions[i]
          }
          if(this.permissions[i] == 'sys_user_del'){
            this.sys_user_del = this.permissions[i]
          }
      }
    },
    methods: {
      refresh(){
        this.getList();
        this.radio = undefined;
        this.derail = true;
        this.coldderail = true;
        this.nocoldderail = true;
      },
      //获取字典数据
      dictionarydata(){
        dictionary(objKeySort()).then(response => {
          this.dictionarylist= response.data.data
        })
      },

      //字典数据转化
      setWorktype(data){
        let worktype = data.split(','),typename='';
        for(var i=0;i<worktype.length;i++){
          for(var j=0;j<this.dictionarylist.worktype.length;j++){
            if(Number(worktype[i]) == this.dictionarylist.worktype[j].id){
                typename+=' '+this.dictionarylist.worktype[j].name
            }
          }
        }
        return typename
      },

      //设置技能转化
      setskill(data){
        let worktype = data.split(','),typename='';
                for(var i=0;i<worktype.length;i++){
                  for(var j=0;j<this.dictionarylist.worker_skill.length;j++){
                    if(Number(worktype[i]) == this.dictionarylist.worker_skill[j].id){
                        typename+=' '+this.dictionarylist.worker_skill[j].name
                    }
                  }
                }
        return typename
      },



      showRow(row){
        console.log(123)
        this.radio = row.userId;
        this.derail =false;
        if(row.status == 1){
          this.coldderail = false;
          this.nocoldderail = true;
        }else{
          this.coldderail = true;
          this.nocoldderail = false;
        }
      },

      getList() {
        this.listLoading = true
        this.form.pageNum=this.page.currentPage
        this.form.pageSize = this.page.pageSize
        fetchList(objKeySort(this.form)).then(response => {
           this.list = response.data.data.rows
           this.page.total = response.data.data.total
           this.listLoading = false
        })
      },


      //搜索
      searchChange() {
        this.getList()
      },
      //分页
      sizeChange(val) {
        this.page.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.getList()
      },

      handleStart(){
           stop(objKeySort({userId:this.radio,status:1})).then(response =>{
            this.$message({
                title: '解冻成功',
                message: '解冻成功',
                type: 'success',
                duration: 2000
              })
              this.refresh()
        })
      },
      //删除
      deletestate(){
           this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWorker(objKeySort({userId : this.radio})).then(response => {
              this.refresh()
                this.$message({
                type: 'success',
                message: '删除成功!'
              });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //查看
      examine() {
        this.$refs.childworker.setsataus(this.radio,this.dictionarylist);
      },
      //冻结
      handleStop() {
        this.$refs.childcald.setsataus(this.radio,"冻结原因");
      }
    }
  }
</script>
